import { Fragment, useState } from 'react';
import styled from 'styled-components';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { CardRow, Card, IconWrapper, Icon, Title, PageTitle } from '../../components/StyledComponents';
// components
import Deposit from './Deposit';
import Withdrawal from './Withdrawal';
import Transfer from './Transfer';
import LoanCollection from './LoanCollection';
import NewCustomer from './Customers/NewCustomer';

const Text = styled.p`
	font-weight: ${props => props.weight};
	font-size: ${props => props.size};
	line-height: ${props => props.spacing};
	margin-top: ${props => props.mt};
	margin-right: ${props => props.mr};
`;
const CardFooter = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

const Marketer = () => {
	const [depositOpen, setDepositOpen] = useState(false);
	const [withdrawal, setwithdrawal] = useState(false);
	const [transfer, setTransfer] = useState(false);
	const [loan, setLoan] = useState(false);
	const [onboard, setOnboard] = useState(false);
	return (
		<Fragment>
				<PageTitle>Customer Center</PageTitle>
				<CardRow>
					<Card onClick={() => setDepositOpen(true)}>
						<IconWrapper bg="#1890FF">
							<Icon src="/assets/depo.png" alt="" />
						</IconWrapper>
						<Title>Deposit</Title>
					</Card>
					<Card onClick={() => setwithdrawal(true)}>
						<IconWrapper bg="#47D024">
							<Icon src="/assets/withdraw.png" alt="" />
						</IconWrapper>
						<Title>Withdrawal</Title>
					</Card>
					<Card onClick={() => setTransfer(true)}>
						<IconWrapper bg="#FF0000">
							<Icon src="/assets/transfer.png" alt="" />
						</IconWrapper>
						<Title>Transfer</Title>
					</Card>
				</CardRow>
				<CardRow style={{ marginTop: '2rem' }}>
					<Card onClick={() => setOnboard(true)}>
						<Title weight="700" size="1.25rem" style={{ display: 'flex', flexDirection: 'row-reverse' }}>
							<AddCircleIcon style={{ fontSize: '2.5rem', marginLeft: '0.5rem', color: '#F43232' }} />
							<span>Onboard</span>
						</Title>
						<CardFooter>
							<Text size="0.875rem" spacing="15px" mt="0.5rem" mr="0.75rem">
								Select product to fulfil <br /> customer financial needs.
							</Text>
						</CardFooter>
					</Card>
					<Card onClick={() => setLoan(true)}>
						<Title weight="700" size="1.25rem">Loan collection</Title>
						<Text size="0.875rem" mt="0.5rem">20 loans</Text>
						<CardFooter style={{ borderTop: '1px solid gray', marginTop: '0.5rem'}}>
							<Text size="0.875rem" spacing="15px">
								View all
							</Text>
							<ChevronRightIcon sx={{ cursor: 'pointer' }} />
						</CardFooter>
					</Card>
				</CardRow>
				<>
					{
						depositOpen === true && 
						<Deposit depositOpen={depositOpen} close={() => setDepositOpen(false)} />
					}
					{
						withdrawal === true &&
						<Withdrawal open={withdrawal} close={() => setwithdrawal(false)} />
					}
					{
						transfer === true &&
						<Transfer open={transfer} close={() => setTransfer(false)} />
					}
					{
						loan === true &&
						<LoanCollection open={loan} close={() => setLoan(false)} />
					}
					{
						onboard === true &&
						<NewCustomer open={onboard} close={() => setOnboard(false)} />
					}
				</>
		</Fragment>
	)
}

export default Marketer;